export default __webpack_public_path__ + "static/media/icon_search_gray.81a88965.svg";